class ReviewAnchorButton extends HTMLElement {
  connectedCallback() {
    const productAnchor = this.getAttribute('product-handle');
    this.button = this.querySelector('a');

    if (this.button && productAnchor) {
      this.handleClick = () => {
        document.dispatchEvent(new CustomEvent('review:anchorClicked', {
          detail: productAnchor
        }));
      };

      this.button.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.button && this.handleClick) {
      this.button.removeEventListener('click', this.handleClick);
    }
  }
}

if (!customElements.get('review-anchor-button')) customElements.define('review-anchor-button', ReviewAnchorButton)
